import React from "react";
import { Layout } from "@/components/Layout";
import { UserManagementPanel } from "@/components/UserManagement";
import { motion } from "framer-motion";
import { Users, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

const UserSystem: React.FC = () => {
  const { t } = useLanguage();
  return (
    <Layout>
      <div className="flex flex-col gap-8 pb-10 text-[13px] lg:text-base">
        {/* Header Section */}
        <header className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-primary font-medium mb-1">
              <ShieldCheck className="w-4 h-4" />
              <span className="text-sm uppercase tracking-wider font-mono">{t.users.adminControl}</span>
            </div>
          </div>
        </header>

        {/* Main Management Panel */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.19, 1, 0.22, 1] }}
          className="w-full"
        >
          <div className="bg-card rounded-2xl border border-border shadow-md overflow-hidden">
            <div className="p-1 bg-gradient-to-r from-primary/20 via-transparent to-primary/20" />
            <div className="p-6">
              <UserManagementPanel />
            </div>
          </div>
        </motion.div>

        {/* Info Footer */}
        <footer className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-4 rounded-lg bg-muted/50 border border-border/50">
            <h3 className="text-sm font-semibold mb-2 flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-primary" />
              {t.users.cascadingStatus}
            </h3>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {t.users.cascadingStatusDesc}
            </p>
          </div>
          <div className="p-4 rounded-lg bg-muted/50 border border-border/50">
            <h3 className="text-sm font-semibold mb-2 flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-amber-500" />
              {t.users.ticketPricing}
            </h3>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {t.users.ticketPricingDesc}
            </p>
          </div>
          <div className="p-4 rounded-lg bg-muted/50 border border-border/50">
            <h3 className="text-sm font-semibold mb-2 flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-blue-500" />
              {t.users.fightPercentage}
            </h3>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {t.users.fightPercentageDesc}
            </p>
          </div>
        </footer>
      </div>
    </Layout>
  );
};

export default UserSystem;
